// 文件有效，为国际化做准备
export default {
  pagination: {
    itemsPerPage: '{size} 条/页',
    jumpTo: '跳至',
    page: '页',
    total: '共 {total} 项数据',
  },
  cascader: {
    empty: '暂无数据',
    loadingText: '',
    placeholder: '请选择',
  },
  calendar: {
    yearSelection: '{year} 年',
    monthSelection: '{month} 月',
    yearRadio: '年',
    monthRadio: '月',
    hideWeekend: '隐藏周末',
    showWeekend: '显示周末',
    today: '今天',
    thisMonth: '本月',
    week: '一,二,三,四,五,六,日',
    cellMonth: '一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月',
  },
  transfer: {
    title: '{checked} / {total} 项',
    empty: '暂无数据',
    placeholder: '请输入关键词搜索',
  },
  timePicker: {
    now: '此刻',
    confirm: '确定',
    anteMeridiem: '上午',
    postMeridiem: '下午',
    placeholder: '选择时间',
  },
  dialog: {
    confirm: '确认',
    cancel: '取消',
  },
  drawer: {
    confirm: '确认',
    cancel: '取消',
  },
  popconfirm: {
    confirm: '确定',
    cancel: '取消',
  },
  table: {
    empty: '暂无数据',
    loadingText: '正在加载中，请稍后',
    loadingMoreText: '',
    filterInputPlaceholder: '请输入内容（无默认值）',
    sortAscendingOperationText: '点击升序',
    sortCancelOperationText: '点击取消排序',
    sortDescendingOperationText: '点击降序',
  },
  select: {
    empty: '暂无数据',
    loadingText: '加载中',
    placeholder: '-请选择-',
  },
  tree: {
    empty: '暂无数据',
  },
  treeSelect: {
    empty: '暂无数据',
    loadingText: '加载中',
    placeholder: '请选择',
  },
  datePicker: {
    placeholder: {
      date: '请选择日期',
      month: '请选择月份',
      year: '请选择年份',
    },
    weekdays: ['一', '二', '三', '四', '五', '六', '日'],
    months: ['1 月', '2 月', '3 月', '4 月', '5 月', '6 月', '7 月', '8 月', '9 月', '10 月', '11 月', '12 月'],
    rangeSeparator: ' 至 ',
    direction: 'ltr',
    format: 'YYYY-MM-DD',
    dayAriaLabel: '日',
    weekAbbreviation: '周',
    yearAriaLabel: '年',
    monthAriaLabel: '月',
    confirm: '确定',
    selectTime: '选择时间',
    selectDate: '选择日期',
    nextYear: '下一年',
    preYear: '上一年',
    nextMonth: '下个月',
    preMonth: '上个月',
    preDecade: '上个十年',
    nextDecade: '下个十年',
    now: '当前',
  },
  steps: {},
  upload: {
    sizeLimitMessage: '图片大小不能超过 {sizeLimit}',
    cancelUploadText: '取消上传',
    triggerUploadText: {
      fileInput: '选择文件',
      image: '点击上传图片',
      normal: '点击上传',
      reupload: '重新上传',
      delete: '删除',
    },
    dragger: {
      dragDropText: '释放鼠标',
      draggingText: '拖拽到此区域',
      clickAndDragText: '点击上方“选择文件”或将文件拖拽到此区域',
    },
    file: {
      fileNameText: '文件名',
      fileSizeText: '文件大小',
      fileStatusText: '状态',
      fileOperationText: '操作',
      fileOperationDateText: '上传日期',
    },
    progress: {
      uploadingText: '上传中',
      waitingText: '待上传',
      failText: '上传失败',
      successText: '上传成功',
    },
  },
  list: {
    loadingText: '正在加载中，请稍等',
    loadingMoreText: '点击加载更多',
  },
};
